import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import Logger from 'observability/Logger';

const LOG = new Logger('GoogleMapsApiClient');

const API_BASE_URL = 'https://maps.googleapis.com/maps/api';

function getGoogleMapsWSApiKey() {
    const bootstrap = getBootstrap();
    const apiKey = bootstrap.get('googleMapsWsKey');
    if (!apiKey) {
        LOG.warn('Missing googleMapsWsKey');
    }

    return apiKey;
}

export default class GoogleMapsApiClient {
    constructor({ baseUrl = API_BASE_URL, apiKey } = {}) {
        this.apiKey = apiKey;
        this.baseUrl = baseUrl;
    }

    /**
     * Does a GET request to the Splash API
     *
     * @param  {string} apiPath - relative path on the API
     * @param  {Object} params - query parameters sent with the request
     * @param  {Object} [options] - any additional options to set for the request
     * @return {Promise} resolves with the response body
     */
    get(apiPath, params, options = {}) {
        return axios.get(this.apiUrl(apiPath), {
            params: { ...params, key: this.apiKey },
            ...options,
        });
    }

    /**
     * Generates a full API URL from the given path
     *
     * @param  {string} apiPath - relative path on the API
     * @return {string} full API URL
     */
    apiUrl(apiPath) {
        // Make sure we don't double the slash on the API path
        return `${this.baseUrl}/${apiPath.replace(/^\/?(.*)/, '$1')}`;
    }

    /**
     * @return {Promise}
     */
    getLocationTimezone({ latitude, longitude } = {}, fetchOptions = {}) {
        if (!latitude || !longitude) {
            return Promise.reject(new Error('Missing required latitude and longitude'));
        }

        const params = {
            ...fetchOptions,
            location: `${latitude},${longitude}`,
            timestamp: Math.round(new Date().getTime() / 1000).toString(),
        };

        const url = '/timezone/json';
        return this.get(url, params, fetchOptions).then((response) => response.data);
    }
}

export const getGoogleMapsApiClient = () => new GoogleMapsApiClient({ apiKey: getGoogleMapsWSApiKey() });
